var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"fill-in header-main-layout"},[_c('el-header',[_c('HomeHeader')],1),_c('el-main',{staticClass:"main-container",class:{ 'main-container--news': _vm.$route.path === '/information' }},[_c('router-view'),_c('FeedbackBut')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }